import { Stack, TextField } from "@mui/material"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { IBuildingSelection } from "../../models/dashboard"
import BuildingSelect from "../BuildingSelection/BuildingSelect"

const dashboardStyles = {
    dates: {
        marginBottom : 1, 
        marginTop : 0,
    }
}

interface DashboardHeaderProps {
    start : Date | null,
    setStart : Function,
    end : Date | null,
    setEnd : Function,
    buildingId : number | undefined,
    setBuildingId : Function,
    buildingSelections: IBuildingSelection[] | undefined,
}
const getDateNow = () => {
    const date = new Date();
    date.setHours(0,0,0,0);

    return date;
}

const maxDate = getDateNow();

const DashboardHeader = (props:DashboardHeaderProps) => {
    const {start,setStart, end, setEnd, buildingId, setBuildingId, buildingSelections} = props;

    return (
        <Stack direction="row" spacing={2} {...dashboardStyles.dates}>
            <LocalizationProvider dateAdapter={AdapterDateFns} >
                        <DatePicker
                            label="From"
                            value={start}
                            maxDate={maxDate}
                            onChange={(newValue) => setStart(newValue)}
                            renderInput={(params) => <TextField {...params} />}
                        />
                        <DatePicker
                            label="To"
                            minDate={start}
                            maxDate={maxDate}
                            value={end}
                            onChange={(newValue) => setEnd(newValue)}
                            renderInput={(params) => <TextField {...params} />}
                        />
            </LocalizationProvider>
            <BuildingSelect 
                buildingId={buildingId as number} 
                setBuildingId={setBuildingId} 
                buildingSelections={buildingSelections}/>
        </Stack>
    )
}


export default DashboardHeader;
